import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ palette, spacing, shadows }) => ({
  outerBox: {
    margin: "1em",
    padding: "1em",
    borderRadius: "8px",
    background: palette.common.white,
    boxShadow: shadows[2]
  },
  header: {
    color: palette.text.primary,
    marginBottom: spacing(4)
  },
  innerBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100px",
    padding: spacing(6, 6),
    backgroundColor: palette.primary[50],
    borderRadius: spacing(1),
    border: `1px solid ${palette.primary[100]}`
  },
  icon: {
    width: 60,
    height: 60
  },
  title: {
    color: palette.text.primary,
    textAlign: "center",
    fontWeight: 500
  },
  description: {
    color: palette.text.primary,
    textAlign: "center",
    fontWeight: "normal",
    fontSize: "20px"
  }
}))
